import { EGender } from '../enums/gender.enum';
import { GenderRecord } from '../types/gender.type';

export const GENDER_OPTIONS: GenderRecord = {
  [EGender.male]: {
    id: EGender.male,
    value: EGender.male,
    viewValue: 'M',
  },
  [EGender.female]: {
    id: EGender.female,
    value: EGender.female,
    viewValue: 'F',
  },
};
